import { System } from '../System';
import { BaseListener, BaseObserver } from '../utils/BaseObserver';
import { autorun, makeObservable, observable } from 'mobx';
import { v4 } from 'uuid';
import { DateTime } from 'luxon';
import { Routes } from '../routes';
import * as _ from 'lodash';

export interface NotificationOptions {
  label: string;
  text: string;
  date: Date;
  action: (notification: Notification) => any;
}

export interface NotificationListener extends BaseListener {
  closed: () => any;
  navigate: (url: string) => any;
}

export class Notification extends BaseObserver<NotificationListener> {
  id: string;

  constructor(public options: NotificationOptions) {
    super();
    this.id = v4();
  }

  action() {
    this.options.action?.(this);
    this.close();
  }

  close() {
    this.iterateListeners((cb) => cb.closed?.());
  }

  get relativeTime() {
    return DateTime.fromJSDate(this.options.date).toRelative();
  }

  navigate(url: string) {
    this.iterateListeners((cb) => cb.navigate?.(url));
  }
}

export class NotificationStore {
  initialized: boolean;

  @observable
  _notifications: Set<Notification>;

  constructor(private system: System) {
    this._notifications = new Set();
    this.initialized = false;
    makeObservable(this);
  }

  public addNotification(n: Notification) {
    this._notifications.add(n);
    n.registerListener({
      closed: () => {
        this._notifications.delete(n);
      }
    });
  }

  get notifications() {
    return Array.from(this._notifications);
  }

  init() {
    if (this.initialized) {
      return;
    }
    // TODO load notifications when we have such a service
    this.initialized = true;
  }
}
